import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";

export function SelectFiltered(props: {
    label: string;
    value: string;
    onChange(value: string): void;
    options: (Opt | null)[];
    disabled?: boolean;
}) {


    return (
        <FormControl size="small" fullWidth disabled={props.disabled}>
            <InputLabel>{props.label}</InputLabel>
            <Select value={props.value} label={props.label} size="small"
                    disabled={props.disabled} fullWidth
                    onChange={(e, c) => props.onChange(e.target.value)}>
                {[
                    ...(props.options.find(v => v && v.value === "") ? [] : [{ value: "", display: "(none)", disabled: false }]),
                    ...props.options
                ].map(o => {
                    if(!o) return null;
                    return <MenuItem disabled={o.disabled} value={o.value}>{o.display}</MenuItem>
                })}
            </Select>
        </FormControl>
    )
}

export type Opt = {
    value: string
    display: string;
    disabled?: boolean;
}